import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextField,
  Button,
  Box,
} from "@mui/material";

const INITIAL_VALUES = {
  name: "",
};

export default function PresentationFormDialog({
  open,
  onClose,
  onSave,
  rowId,
  presentation,
}) {
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    if (!open) return;

    if (rowId && presentation) {
      setData({
        name: presentation.name || "",
      });
    } else {
      setData(INITIAL_VALUES);
    }
  }, [rowId, presentation, open]);

  const handleClose = () => {
    setData(INITIAL_VALUES);
    onClose();
  };

  const isValid = data.name.trim() !== "";

  const handleSave = () => {
    onSave({
      name: data.name.trim(),
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {rowId ? "Edit Presentation" : "Create Presentation"}
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          {rowId
            ? "Update the presentation name."
            : "Enter the presentation name (e.g. Single, 2 Pack, 12 Pack Premium)."}
        </DialogContentText>

        <Box
          autoComplete="off"
          sx={{ display: "flex", flexDirection: "column", gap: 3 }}
        >
          <TextField
            label="Name"
            fullWidth
            required
            autoComplete="off"
            value={data.name}
            onChange={(e) =>
              setData({ ...data, name: e.target.value })
            }
            helperText="e.g. Single, 2 Pack, 12 Pack"
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={!isValid}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}